import { useQuery } from "@tanstack/react-query"
import { AutocompleteType, LocatorStationsWrapper, Station } from "api"
import { StationMapRequest, postMapStations } from "lib/api"

interface UseStationQueryOptions {
    filters: any
    selectedCity: any
    queryParams: StationMapRequest | null
    initialFiltersAreReady: boolean
    isApiReady: boolean
    initialStations: LocatorStationsWrapper
    onResponse: (data: LocatorStationsWrapper, isStation: boolean) => void
}

export const useStationQuery = ({
    filters,
    selectedCity,
    queryParams,
    initialFiltersAreReady,
    isApiReady,
    initialStations,
    onResponse
}: UseStationQueryOptions) => {

    const query = useQuery<LocatorStationsWrapper>({
        queryKey: ["filters", filters, selectedCity, queryParams],
        queryFn: async () => {
            const params: StationMapRequest = queryParams!
            const stationsRes = await postMapStations(params)
            const data = stationsRes

            const isSelectedStation = selectedCity?.type === AutocompleteType.Station
            onResponse(data, isSelectedStation)
            return data
        },
        enabled: (!!filters || !!selectedCity) && initialFiltersAreReady && isApiReady,
        refetchOnWindowFocus: false,
        initialData: initialStations,
    })

    return query
}

interface UseStationInteractionsOptions {
    isDesktop: boolean
    setSelectedLocation: (station: Station) => void
    setShowCarousel: (show: boolean) => void
}

export const useStationInteractions = ({
    isDesktop,
    setSelectedLocation,
    setShowCarousel
}: UseStationInteractionsOptions) => {

    const handleStationClick = (station: Station) => {
        setSelectedLocation(station)
        if (!isDesktop) {
            setShowCarousel(true)
        }
    }

    return {
        handleStationClick
    }
}
